import { BaseFinalCommand } from "namirasoft-node-cli";

export class AccountConfigCommand extends BaseFinalCommand
{
    constructor(argv: string[])
    {
        super(argv, ["token"], []);
    }
    override async exec()
    {
        this.app.storage.setNSAToken(this.arg_values[0]);
    }
};